(ns entities.brand.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.brand.specs :as sp]
    )
  )

(def path [:entities :brand])

(rf/reg-entity
  :brand
  {:get
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/brand data)
                :name :brand
                :success [:brand/fetched]
                :error [:brand/fetch-errored]
                :allow-unauth? true
                }})

   :spec/get ::sp/get})

(rf/reg-event-db
  :brand/fetched
  (rf/path path)
  (fn [_ [data]]
    (:brand data)))
